import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-black/80 backdrop-blur-md text-white/70 text-sm py-4 mt-12">
      <div className="max-w-5xl mx-auto px-6 flex flex-col gap-3">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2">
          <div>
            © {new Date().getFullYear()} CruiseRadar · by Vessel Vibes
          </div>
          <div className="flex gap-4">
            <Link to="/about" className="hover:text-white">
              About
            </Link>
            <Link to="/privacy" className="hover:text-white">
              Privacy Policy
            </Link>
          </div>
        </div>
        <p className="text-xs text-white/40 text-center leading-relaxed">
          Fuel consumption and cost figures are estimates calculated using a proprietary algorithm. CruiseRadar makes no representations as to their accuracy and shall not be liable for any decisions made in reliance on this data. All figures are for informational purposes only and should not be used for commercial, operational, or legal purposes.
        </p>
      </div>
    </footer>
  );
}
